import { useState, useEffect } from 'react';
import '../../../../css/custom-scrollbar.css';
import { useMyContext } from '../../../../context/MyContext';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PaginationItem from '@mui/material/PaginationItem';
import { MdDashboard } from 'react-icons/md';
import { ndrList, Base_Url, ndr, pendingApi, ndrStatusList, ndrAction } from '../../../../config/config';
import { toast } from 'react-toastify';
import { CgSearch } from "react-icons/cg";
import FullPageLoader from '../../../../component/fullPageLoader/fullPageLoader';
import Ndrmodel from '../../../../component/b2c/models/ndrModel';
import axios from 'axios';


export default function NDRDashboard() {
  const [activeTab, setActiveTab] = useState('Action Pending');
   const [isPageLoading, setIsPageLoading] = useState(false)
  const { setorderId } = useMyContext()
  const [limit, setLimit] = useState(10);
  const [ndrListData, setNdrListData] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [originalData, setOriginalData] = useState([]);
  // Add new state to track API total separately
  const [apiTotalItems, setApiTotalItems] = useState(0);
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [ndrdata, setNdrData] = useState([]);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [pagination, setPagination] = useState({
    'Action Pending': 1,
    'Action Taken': 1,
    'RTO Delivered': 1,
    'All Details': 1,
  });

  const navigateForTrack = useNavigate();
  const tabs = ['Action Pending', 'Action Taken', 'RTO Delivered', 'All Details'];
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');

  // const handleViewClick = (ndr) => {
  //   setNdrData(ndr);
  //   setIsPopupOpen(true)
  // }

  // handleViewClick function
  const handleViewClick = (ndr) => {
    if (ndr.order_partner?.toLowerCase() === "ekart") {
      // open modal only for ekart
      setNdrData(ndr);
      setIsPopupOpen(true);
    } else {
      // directly call API for others
      handleRemmitance(ndr);
    }
  };

  // onSubmit function
  const handleRemmitance = async (data) => {
    setIsPageLoading(true);
    const editNdrEndpoint = Base_Url + ndrAction;

    const payload = {
      order_id: data.order_id,
      // address: data.order_drop_address,
      // phone: data.order_phone,
      action: "Re-attempt",
    };

    try {
      const response = await axios.post(editNdrEndpoint, payload, {
        headers: {
          token: token,
          cus_id: cusid,
          "Content-Type": "application/json",
        },
      });

      if (response.data.status === "SUCCESS") {
        fetchNdrListByCurrentTab();
        toast.success(response.data.message || "NDR data updated successfully");
        setIsPageLoading(false);
      } else {
        toast.error(response.data.message || "Failed to update NDR data");
         setIsPageLoading(false);
      }
    } catch (error) {
      const errorData = error.response?.data;
      if (errorData?.messages && typeof errorData.messages === "object") {
        const detailedErrors = Object.values(errorData.messages).join(", ");
        toast.error(detailedErrors || "Validation error occurred");
         setIsPageLoading(false);
      } else {
        toast.error(errorData?.message || "An error occurred while updating NDR data");
         setIsPageLoading(false);
      }
    } finally {
      setIsPageLoading(false);
    }
  };


  const handleClose = () => {
    setIsPopupOpen(false);
    setNdrData(ndr);
  };

  useEffect(() => {
    fetchNdrListByCurrentTab();
  }, [activeTab, pagination[activeTab], limit]);

  // Fixed search functionality
  useEffect(() => {
    if (searchQuery.trim() === '') {
      setNdrListData(originalData);
      // When search is cleared, show filtered count for display but keep API total for pagination
      setTotalOrders(apiTotalItems);
    } else {
      const filtered = originalData.filter(item =>
        item.waybill?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setNdrListData(filtered);
      // When searching, show filtered count
      setTotalOrders(filtered.length);
    }
  }, [searchQuery, originalData, apiTotalItems]);

  const renderTableHeaders = () => {
    const commonHeaders = ['Order ID', 'AWB No.', 'NDR Count', 'Reason', 'Last Updated'];

    if (activeTab === 'Action Pending' || activeTab === 'All Details' || activeTab === 'Action Taken') {
      return [...commonHeaders, 'Action'];
    }
    return commonHeaders;
  };

  const fetchNdrListByCurrentTab = async () => {
    const pageNumber = pagination[activeTab];
    const limitNumber = Number(limit) || 10;
    setIsPageLoading(true);
    try {
      let url = '';
      if (activeTab === 'Action Pending') {
        url = `${Base_Url}${ndrList}/Pending?page=${pageNumber}&limit=${limitNumber}`;
      } else if (activeTab === 'Action Taken') {
        url = `${Base_Url}${ndrStatusList}?page=${pageNumber}&limit=${limitNumber}`;
      } else if (activeTab === 'RTO Delivered') {
        url = `${Base_Url}${ndrList}/RTO?page=${pageNumber}&limit=${limitNumber}`;
      } else if (activeTab === 'All Details') {
        url = `${Base_Url}${ndrList}?page=${pageNumber}&limit=${limitNumber}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cusid || '',
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (result.status === "SUCCESS") {
        // const data = result.data;
        const data = Array.isArray(result.data) ? result.data : []; 
        const totalItems = result.pagination?.totalItems || 0;
 
        setOriginalData(data);
        setNdrListData(data);
        // setPartner(data.data[0].order_partner)
        setApiTotalItems(totalItems);
        setTotalOrders(totalItems);
        setIsPageLoading(false);

      } else {
        toast.error(result.message || "Failed to fetch data");
        setNdrListData([]);
        setTotalOrders(0);
        setOriginalData([]);
        setApiTotalItems(0);
        setIsPageLoading(false);
      }
    } catch (error) {
      console.error('API error:', error.message);
      toast.error("An error occurred while fetching data");
      setNdrListData([]);
      setTotalOrders(0);
      setOriginalData([]);
      setApiTotalItems(0);
       setIsPageLoading(false);
    }
  };

  const handlePaginationChange = (event, value) => {
    setPagination(prev => ({
      ...prev,
      [activeTab]: value,
    }));
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPagination(prev => ({
      ...prev,
      [activeTab]: 1,
    }));
  };

  const handleReturn = async (order_id, action) => {
    try {
      const urlPost = Base_Url + ndrAction;
      setIsPageLoading(true);
      const response = await fetch(urlPost, {
        method: 'POST',
        headers: {
          token: token,
          cus_id: cusid || '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_id: order_id,
          action: action
        }),
      });

      const result = await response.json();

      if (result.status === "SUCCESS") {
        fetchNdrListByCurrentTab();
        toast.success(result.message);
        setIsPageLoading(false);
      } else {
        toast.error(result.message || "Action failed");
        setIsPageLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred while processing your request");
      console.error('API error:', error.message);
      setIsPageLoading(false);
    }
  };


  const handleClick = (orderID) => {
    setorderId(orderID);
    navigateForTrack("/shipments/tracking ");
  }

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };

  const TAB_ICONS = {
    'Action Pending': (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    'Action Taken': (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    'RTO Delivered': (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17l-5-5m0 0l5-5m-5 5h12a4 4 0 010 8h-1" />
      </svg>
    ),
    'All Details': (
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  };

  const renderTableRow = (item, index) => {
    // const customerName = item.order_first_name && item.order_last_name
    //   ? `${item.order_first_name} ${item.order_last_name}`
    //   : (item.order_first_name || "N/A");


    const commonCells = [
      <td
        key="orderId"
        onClick={() => handleClick(item.order_id)}
        className="relative group px-3 py-2.5 text-xs text-gray-900 dark:text-white cursor-pointer hover:underline decoration-1 underline-offset-2 font-semibold transition-colors"
      >
        {item.order_id || "N/A"}

        {/* Tooltip */}
        <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-black dark:bg-gray-800 text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-20 whitespace-nowrap">
          📦 Track your shipment status here!
          <div className="absolute -top-1 left-3 w-2 h-2 bg-black dark:bg-gray-800 rotate-45"></div>
        </div>
      </td>,

      <td key="awbNo" className="px-3 py-2.5 text-xs text-gray-700 dark:text-gray-100 font-medium">
        {item.waybill || "N/A"}
      </td>,

      // <td key="customerInfo" className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">
      //   {customerName}
      // </td>,

      <td key="count" className="px-3 py-2.5 text-xs text-gray-700 dark:text-gray-300 font-medium">
        {item.count || "N/A"}
      </td>,

      <td key="reason" className="px-3 py-2.5">
        <span className="inline-flex items-center px-2.5 py-1 rounded-md text-[11px] font-medium bg-gray-100 text-gray-800 border border-gray-200 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600">
          {item.reason || "N/A"}
        </span>
      </td>,

      <td key="lastUpdated" className="px-3 py-2.5 text-xs text-gray-500 dark:text-gray-400 font-mono">
        {item.updated_at || "N/A"}
      </td>,
    ];


    if (activeTab === 'Action Pending') {
      commonCells.push(
        <td key="action" className="px-3 py-2.5">
          <div className="flex items-center gap-1.5">
            <Button
              variant="contained"
              size="small"
              onClick={() => handleViewClick(item)}
              disableElevation
              className="min-w-0 p-1 rounded-md"
              style={{
                backgroundColor: '#111111',
                textTransform: 'capitalize',
                fontSize: '10px',
                padding: '4px 10px',
                minHeight: '24px'
              }}
            >
              Reattempt
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleReturn(item.order_id, 'Return')}
              disableElevation
              className="min-w-0 p-1 rounded-md"
              style={{
                borderColor: '#111111',
                color: '#111111',
                textTransform: 'capitalize',
                fontSize: '10px',
                padding: '4px 10px',
                minHeight: '24px'
              }}
            >
              Return
            </Button>
          </div>
        </td>
      );
    } else if (activeTab === 'All Details' || activeTab === 'Action Taken') {
      commonCells.push(
        <td key="action" className="px-3 py-2.5">
          <span className="inline-flex items-center px-2.5 py-1 rounded-md text-[10px] font-medium bg-black text-white dark:bg-white dark:text-black">
            {item.action || "N/A"}
          </span>
        </td>
      );
    }

    return (
      <tr
        key={index}
        className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800/60 transition-colors duration-150"
      >
        {commonCells}
      </tr>
    );
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setPagination(prev => ({
      ...prev,
      [tab]: 1,
    }));
    setSearchQuery('');
  };

  const NoDataMessage = () => (
    <tr>
      <td colSpan={renderTableHeaders().length} className="p-10 text-center">
        <div className="flex flex-col items-center gap-2 text-gray-400">
          <CgSearch size={28} />
          <span className="text-sm font-medium">No data available</span>
        </div>
      </td>
    </tr>
  );

  // Calculate pagination count based on whether search is active
  const getPaginationCount = () => {
    if (searchQuery.trim() !== '') {
      // When searching, disable pagination (show all results on one page)
      return 1;
    }
    // When not searching, use API total for pagination
    return Math.ceil(apiTotalItems / limit) || 1;
  };
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: '113px', height: 'calc(100vh - 115px)', overflowY: 'auto' }
                : {}
            }
          >
            <Sidebar />
          </div>
        )}


        <FullPageLoader
        isLoading={isPageLoading}
        message="Processing your request..."
      />

        {/* Main content — fills remaining height exactly, no page-level scroll */}
        <div className="flex-1 flex flex-col overflow-hidden bg-gray-200 dark:bg-darkmodeColor px-4 md:px-6 py-4 gap-3">

          {/* Header row: title + search, single compact bar */}
          <div className="flex items-center justify-between gap-3 flex-wrap flex-shrink-0">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-black flex items-center justify-center flex-shrink-0">
                <MdDashboard className="text-white text-xl" />
              </div>
              <div>
                <h1 className="text-base sm:text-lg font-bold text-gray-900 dark:text-white leading-tight">NDR Dashboard</h1>
                <p className="text-[11px] text-gray-400 dark:text-gray-400">Manage non-delivery reports</p>
              </div>
            </div>

            <div className="relative w-full sm:w-72">
              <div className="flex items-center bg-white dark:bg-[rgba(1,14,78,0.8)] border border-gray-200 dark:border-gray-600 rounded-lg shadow-sm focus-within:border-black dark:focus-within:border-white transition-colors duration-200">
                <div className="pl-3 pr-2">
                  <CgSearch className="text-gray-400 dark:text-gray-300" size={16} />
                </div>
                <input
                  type="text"
                  placeholder="Search by AWB Number..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className="flex-1 py-2 pr-2 bg-transparent outline-none dark:text-white text-gray-800 placeholder-gray-400 dark:placeholder-gray-300 text-xs font-medium"
                />
                {searchQuery && (
                  <button
                    onClick={clearSearch}
                    className="mr-2 p-1 text-gray-400 hover:text-black dark:hover:text-white transition-colors duration-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800"
                  >
                    <span className="sr-only">Clear search</span>
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Tabs — single-row segmented control */}
          <div className="flex-shrink-0  dark:bg-[rgba(1,14,78,0.5)] p-1 rounded-xl flex gap-1 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => handleTabClick(tab)}
                className={`flex items-center justify-center gap-1.5 px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium whitespace-nowrap transition-all duration-200 flex-1 ${activeTab === tab
                  ? 'bg-black/70 text-white shadow-sm'
                  : 'text-gray-600 dark:text-gray-300 border border-gray-400 hover:bg-gray-200 dark:hover:bg-[rgba(1,14,78,0.9)]'
                  }`}
              >
                {TAB_ICONS[tab]}
                <span>{tab}</span>
              </button>
            ))}
          </div>

          {/* Table card — takes remaining height; only this area scrolls */}
          <div className="flex-1 flex flex-col overflow-hidden bg-white dark:bg-darkmodeColor rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm">
            <div className="flex-1 overflow-y-auto overflow-x-auto custom-scrollbar">
              <table className="min-w-full table-auto">
                <thead className="sticky top-0 z-10 bg-black text-white text-[11px] dark:bg-darkmodeColor dark:text-white">
                  <tr>
                    {renderTableHeaders().map((header, index) => (
                      <th key={index} className="px-3 py-2.5 text-left font-semibold">
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {ndrListData.length > 0 ? (
                    ndrListData.map((item, index) => renderTableRow(item, index))
                  ) : (
                    <NoDataMessage />
                  )}
                </tbody>
              </table>
            </div>

            {/* Footer — total count, page size, pagination — always visible, never scrolls */}
            <div className="flex-shrink-0 border-t border-gray-200 dark:border-gray-700 px-3 py-2.5 flex flex-col sm:flex-row justify-between items-center gap-2 bg-white dark:bg-darkmodeColor">
              <span className="text-xs text-gray-600 font-semibold dark:text-gray-300">
                {searchQuery ? `Filtered: ${totalOrders} / Total: ${apiTotalItems}` : `Total Orders: ${totalOrders}`}
              </span>

              <div className="flex items-center gap-2">
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className="border border-gray-200 rounded-md p-1 text-xs bg-white dark:bg-darkmodeColor dark:text-gray-200 dark:border-gray-600"
                  disabled={searchQuery.trim() !== ''} // Disable limit change when searching
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={totalOrders}>All</option>
                </select>
                <Pagination
                  count={getPaginationCount()}
                  page={searchQuery.trim() !== '' ? 1 : pagination[activeTab]} // Always show page 1 when searching
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  className="pagination"
                  size="small"
                  disabled={searchQuery.trim() !== ''} // Disable pagination when searching
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      className={`mx-0.5 dark:bg-darkmodeColor dark:text-white rounded-md ${item.selected ? 'bg-black text-white' : 'text-gray-800'
                        }`}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Ndrmodel isopen={isPopupOpen} onClose={handleClose} ndrdata={ndrdata} />
    </div>
  );
}